import { render, staticRenderFns } from "./CalendarioClinica.vue?vue&type=template&id=d5fec42c&scoped=true"
import script from "./CalendarioClinica.vue?vue&type=script&lang=js"
export * from "./CalendarioClinica.vue?vue&type=script&lang=js"
import style0 from "./CalendarioClinica.vue?vue&type=style&index=0&id=d5fec42c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fec42c",
  null
  
)

export default component.exports